<div class="toast toast-center">
  @if (alert()) {
    <div
      class="alert transform transition-all duration-1000"
      [class.alert-success]="alert()!.type === 'success'"
      [class.alert-error]="alert()!.type === 'error'"
      [class.alert-warning]="alert()!.type === 'warning'"
      [class.alert-info]="alert()!.type === 'info'"
      [class.translate-y-0]="alert()"
      [class.translate-y-40]="!alert()"
      [class.opacity-100]="alert()"
      [class.opacity-0]="!alert()"
    >
      <span>{{ alert()!.text }}</span>
    </div>
  }
</div>
